import {
  DELETE_STEVEDORE,
  SET_LOADING,
  UPDATE_STEVEDORES,
} from './actions/stevedores'
import { RepositoryFactory } from '@/api/RepositoryFactory'

const Stevedore = RepositoryFactory.get('stevedores')

export default {
  namespaced: true,
  state: {
    stevedores: [],
    loading: false,
  },
  getters: {
    getStevedores: state => state.stevedores,
    getStevedore: state => id => state.stevedores.find(s => s.id === id),
    getLoading: state => state.loading,
  },
  actions: {
    fetchStevedores({ commit }, settings = {}) {
      commit(SET_LOADING, true)
      Stevedore.getList(settings)
        .then(res => commit(UPDATE_STEVEDORES, res.data))
        .catch(() => commit(SET_LOADING, false))
    },
  },
  mutations: {
    [UPDATE_STEVEDORES]: (state, items) => {
      state.stevedores = items
      state.loading = false
    },
    [DELETE_STEVEDORE]: (state, { id }) => {
      state.stevedores.splice(
        state.stevedores.findIndex(i => i.id === id),
        1,
      )
    },
    [SET_LOADING]: (state, flag) => {
      state.loading = Boolean(flag)
    },
  },
}
